import React from 'react';
import { Input, Button } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { Logo } from 'assets/img';
import { AuthService } from 'services';

interface Props {
	onClose?: any;
}

class ModalReset extends React.Component<Props> {

	state = {
		email: ''
	}

	submit = async (e: any) => {
		e.preventDefault();
		await AuthService.recover({
			email: this.state.email
		});
		Globals.showSuccess("Se le ha enviado un correo electrónico");
		this.props.onClose();
	}

	render() {
		return (
			<form id="modal-quotes-reset" onSubmit={ this.submit }>
				<div className="text-center">
					<img src={ Logo } className="logo" />
				</div>
				<h4>Ingrese su correo electrónico para iniciar la recuperación de su contraseña</h4>
				<Input
					type="text" 
					name="email"
					onChange={ (e: any) => {
						this.setState({
							email: e.target.value
						});
					} } />
				<div className="text-center">
					<button className="btn" type="submit">
						Continuar
					</button>
				</div>
			</form>
		)
	}
}

export default ModalReset;